var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{on:{"submit":_vm.onSearch,"registration":_vm.onRegistration,"manual":_vm.scrollFormIntoView}}),_c('Forms',_vm._b({},'Forms',_vm.formProps,false,true))],1)}
var staticRenderFns = []

export { render, staticRenderFns }